module.exports = "/_next/static/images/OgUnify-1e03b39a227c111087108e6b74041985.png";